import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Icon } from "app-core";
import IconType = Data.Core.IconType;

@Component({
  selector: 'app-websites',
  templateUrl: './websites.component.html',
  styleUrls: ['./websites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebsitesComponent {
  public externalLinkIcon: Icon = new Icon({
    icon: IconType.externalLinkIcon,
    focus: true,
    badge: {
      size: 'small',
      color: 'accent',
      content: '',
    },
    click: () => { }
  });
}
